export default __webpack_public_path__ + "static/media/epitrochoid.a7eee5c6.gif";